export const manfrediteOnboardingStepAsyncResponseMock = {
    data: {
        status: 'fetching',
        payload: {
            first_name: 'Bartolomé',
            last_name: 'Sagunto'
        }
    },
    message: 'getManfrediteOnboardingStepAsync',
    lang: 'MOCK'
};
//# sourceMappingURL=manfredite-onboarding-step-async.mocks.js.map